/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SubjectRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let person = this.modelFor('people.person').person;

    return hash({
      person,
      subject: store.findRecord('goals/subject', params.subject_id),
      categories: store.query('goals/category', {
        subjectId: params.subject_id,
      }),
      subcategories: store.query('goals/subcategory', {
        subjectId: params.subject_id,
      }),
      goals: store.query('goals/goal', { subjectId: params.subject_id }),
      states: store.query('goals/state', {
        subjectId: params.subject_id,
        personId: person.id,
        current: true,
      }),
    });
  }
}
